export default __webpack_public_path__ + "static/media/visa.bb13d29f.png";